import React from 'react';
import {
  MediaDeviceMenu,
  TrackReference,
  TrackToggle,
  useLocalParticipant,
  VideoTrack,
} from '@livekit/components-react';
import { BackgroundBlur, VirtualBackground } from '@livekit/track-processors';
import { isLocalTrack, LocalTrackPublication, Track } from 'livekit-client';
import Desk from '/assets/background-images/office-bg.jpg';
import Nature from '/assets/background-images/russian-nature.jpg';
import Kremlin from '/assets/background-images/kremlin.jpg';
import styles from '@/styles/call.settings.module.css';
import { cn } from '@/lib/utils.ts';

// Background image paths
const BACKGROUND_IMAGES = [
  { name: 'Офис', path: Desk },
  { name: 'Природа', path: Nature },
  { name: 'Кремль', path: Kremlin },
];

// Background options
type BackgroundType = 'none' | 'blur' | 'image';

export function CameraSettings() {
  const { cameraTrack, localParticipant } = useLocalParticipant();
  const [backgroundType, setBackgroundType] = React.useState<BackgroundType>(
    (cameraTrack as LocalTrackPublication)?.track?.getProcessor()?.name === 'background-blur'
      ? 'blur'
      : (cameraTrack as LocalTrackPublication)?.track?.getProcessor()?.name === 'virtual-background'
        ? 'image'
        : 'none',
  );

  const [virtualBackgroundImagePath, setVirtualBackgroundImagePath] = React.useState<string | null>(
    null,
  );

  const camTrackRef: TrackReference | undefined = React.useMemo(() => {
    return cameraTrack
      ? { participant: localParticipant, publication: cameraTrack, source: Track.Source.Camera }
      : undefined;
  }, [localParticipant, cameraTrack]);

  const selectBackground = (type: BackgroundType, imagePath?: string) => {
    setBackgroundType(type);
    if (type === 'image' && imagePath) {
      setVirtualBackgroundImagePath(imagePath);
    } else if (type !== 'image') {
      setVirtualBackgroundImagePath(null);
    }
  };

  React.useEffect(() => {
    if (isLocalTrack(cameraTrack?.track)) {
      if (backgroundType === 'blur') {
        cameraTrack.track?.setProcessor(BackgroundBlur());
      // } else if (backgroundType === 'bokeh') { // TODO: add more effects
      //
      } else if (backgroundType === 'image' && virtualBackgroundImagePath) {
        cameraTrack.track?.setProcessor(VirtualBackground(virtualBackgroundImagePath));
      } else {
        cameraTrack.track?.stopProcessor();
      }
    }
  }, [cameraTrack, backgroundType, virtualBackgroundImagePath]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
      {/*{camTrackRef && (*/}
      {/*  <VideoTrack*/}
      {/*    style={{*/}
      {/*      maxHeight: '280px',*/}
      {/*      objectFit: 'contain',*/}
      {/*      objectPosition: 'right',*/}
      {/*      transform: 'scaleX(-1)',*/}
      {/*    }}*/}
      {/*    trackRef={camTrackRef}*/}
      {/*  />*/}
      {/*)}*/}

      {/*<section className="button-group">*/}
      {/*  <TrackToggle source={Track.Source.Camera}>Камера</TrackToggle>*/}
      {/*  <div className="button-group-menu">*/}
      {/*    <MediaDeviceMenu kind="videoinput" />*/}
      {/*  </div>*/}
      {/*</section>*/}

      <div style={{ marginTop: '10px' }}>
        <div className={styles.sectionTitle}>Фон (бета)</div>

        <div className={styles.backgroundGrid}>
          <button
            onClick={() => selectBackground('none')}
            className={cn(styles.bgCard, backgroundType === 'none' && styles.bgCardActive)}
          >
            <div
              className={styles.bgPreview}
              style={{
                background: 'linear-gradient(135deg,#333,#111)',
              }}
            />

            <div className={styles.bgOverlay} />

            <div className={styles.bgLabel}>Нет</div>
          </button>

          <button
            onClick={() => selectBackground('blur')}
            className={cn(styles.bgCard, backgroundType === 'blur' && styles.bgCardActive)}
          >
            <div
              className={styles.bgPreview}
              style={{
                background: '#666',
                filter: 'blur(12px)',
              }}
            />

            <div className={styles.bgOverlay} />

            <div className={styles.bgLabel}>Размытие</div>
          </button>

          {BACKGROUND_IMAGES.map((image) => (
            <button
              key={image.path}
              onClick={() => selectBackground('image', image.path)}
              className={cn(
                styles.bgCard,
                backgroundType === 'image' &&
                  virtualBackgroundImagePath === image.path &&
                  styles.bgCardActive
              )}
            >
              <div
                className={styles.bgPreview}
                style={{
                  backgroundImage: `url(${image.path})`,
                }}
              />

              <div className={styles.bgOverlay} />

              <div className={styles.bgLabel}>{image.name}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
